import { SITE_VARIABLES, mq } from '../../themes/variables'
import { StylesObject } from '../../types/styles'

interface ScoreStylesObject extends StylesObject {
    root: StylesObject
    contentWrap: StylesObject
    team: StylesObject
    logo: StylesObject
    scoreType: StylesObject
}

export const getDefaultScoreStylesObj = (
    siteVars: typeof SITE_VARIABLES,
    preview: boolean | undefined,
): ScoreStylesObject => {
    const { COLORS, TEXT_FONT_FAMILY, FONT_SIZE } = siteVars

    const fontHeavy = {
        fontFamily: TEXT_FONT_FAMILY.DEFAULT,
        fontWeight: '800',
        textTransform: 'uppercase',
    }

    return {
        root: {
            margin: '1.5rem 0',
            padding: '1rem 0',
            borderTop: `0.25rem solid ${COLORS.GRAY}`,
            ...(!preview && {
                [mq[2]]: {
                    margin: '2rem 0',
                },
            }),
        },
        contentWrap: {
            ...fontHeavy,
            fontSize: '1.4rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: '1rem',
            color: COLORS.DARK,
        },
        team: {
            ...FONT_SIZE.H1,
            lineHeight: '1.2',
            display: 'flex',
            alignItems: 'center',
        },
        teamScore: {
            color: COLORS.DARKGRAY,
        },
        logo: {
            width: '44px',
            marginRight: '1rem',
        },
        scoreType: {
            ...fontHeavy,
            fontSize: '0.7rem',
            lineHeight: '1',
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: '1rem',
            color: COLORS.MEDIUMGRAY,
        },
    }
}
